import React from 'react';
import Input from '../../containers/Input/Input';

const InputPercent = props => <Input {...props} inputType="percentage" />;

export default InputPercent;
